<div class="with-floating-button">
    <div class="content">
        <page-header *ngIf="isDisplayed"
                     [hidden]="isInDetail"
                     [title]="'admin.frais.factures.title' | translate"
                     [listeItems]="listeTabItems"
                     [selectedIndex]="selectedIndex"
                     (onSelectedItemChange)="onSelectedItemChange($event)"
                     >
        </page-header>
        <router-outlet></router-outlet>
    </div>
</div>
